import { RootState } from '../../../store/rootModel';

export function getPersistedFormValues<T = unknown>(state: RootState, key: string) {
  return state.formPersist.forms[key] as T;
}
